// Copyright (c) 2021-2024. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { PUBLIC_URL } from "../../../../core/constants/frontend";
import { getSeoOgImageUrl } from "../../../../core/constants/route";
import {
    createSendanorSeoImageData,
    isSendanorSeoImageData,
} from "../../../../core/types/SendanorSeoImageData";
import { getPageImage } from "../../../assets/images";
import { OgType } from "../../../core/types/OgType";
import { isPageImage } from "../../../core/types/PageImage";
import { SEOProps } from "./SEO";

export function useSEOProps (props: SEOProps) {

    const ogType = props?.ogType ?? OgType.ARTICLE;

    const { i18n } = useTranslation();
    const location = useLocation();
    const title       = props.title;
    const description = props.description;
    const price       = props.price;
    const buttonText  = props.buttonText;
    const discountText = props.discountText;
    const extraInfo    = props.extraInfo;
    const tagLine      = props.tagLine;
    const siteName : string = props?.siteName ?? 'Sendanor.fi';

    const language = i18n.language;
    const queryString = location.search;
    const pageUrl : string = `${PUBLIC_URL}${location.pathname}${queryString ? `?${queryString}` : ''}`;

    let pageImageUrl : string | undefined = undefined;

    let ogImageWidth : string | undefined;
    let ogImageHeight : string | undefined;
    let ogImageType : string | undefined;

    if (isPageImage(props?.ogImage)) {
        pageImageUrl = getPageImage(props?.ogImage)
    }

    if (isSendanorSeoImageData(props?.ogImage)) {
        pageImageUrl = `${PUBLIC_URL}${getSeoOgImageUrl(props?.ogImage, 'seo.png')}`;
    }

    if (pageImageUrl === undefined) {
        ogImageType = 'image/png';
        ogImageWidth = '1200';
        ogImageHeight = '600';
        pageImageUrl = `${PUBLIC_URL}${getSeoOgImageUrl(createSendanorSeoImageData(
            title,
            description,
            price,
            buttonText,
            discountText,
            extraInfo,
            tagLine
        ), 'seo.png')}`;
    }

    // og:ttl must be between 345600 and 2419200
    const ogTTL : number = 345600;

    return {
        title,
        siteName,
        description,
        pageUrl,
        ogType,
        ogTTL,
        language,
        pageImageUrl,
        ogImageWidth,
        ogImageHeight,
        ogImageType,
    };
}
